module.exports = __webpack_public_path__ + "img/箱包0.ef1644a3.png";